import isDefined from './isDefined';

function compactArray<T>(array: (T | undefined | null)[]) {
  return array.filter(item => {
    return isDefined(item);
  }) as T[];
}

export default compactArray;
